var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShippersEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M220.134 0H80C28.9334 0 0 28.9334 0 80V220.001C0 271.066 28.9334 300 80 300H220.134C271.2 300 300 271.066 300 220.001V80C300 28.9334 271.2 0 220.134 0Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M233.031 161.4V184.844C233.031 197.817 222.559 208.289 209.586 208.289H201.771C201.771 199.692 194.738 192.659 186.142 192.659C177.545 192.659 170.512 199.692 170.512 208.289H139.253C139.253 199.692 132.22 192.659 123.623 192.659C115.027 192.659 107.994 199.692 107.994 208.289H100.179C87.2062 208.289 76.7344 197.817 76.7344 184.844V161.4H162.697C171.294 161.4 178.327 154.366 178.327 145.77V91.0664H192.706C198.333 91.0664 203.491 94.1143 206.304 98.9594L219.667 122.326H209.586C205.288 122.326 201.771 125.842 201.771 130.14V153.585C201.771 157.883 205.288 161.4 209.586 161.4H233.031Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.637 223.919C132.269 223.919 139.267 216.922 139.267 208.29C139.267 199.658 132.269 192.66 123.637 192.66C115.005 192.66 108.008 199.658 108.008 208.29C108.008 216.922 115.005 223.919 123.637 223.919Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M186.137 223.919C194.77 223.919 201.767 216.922 201.767 208.29C201.767 199.658 194.77 192.66 186.137 192.66C177.505 192.66 170.508 199.658 170.508 208.29C170.508 216.922 177.505 223.919 186.137 223.919Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M233.037 149.911V161.398H209.592C205.294 161.398 201.777 157.882 201.777 153.583V130.139C201.777 125.841 205.294 122.324 209.592 122.324H219.673L231.005 142.174C232.333 144.518 233.037 147.175 233.037 149.911Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.512 67.6211H107.994C92.7547 67.6211 80.0949 78.5618 77.3597 93.0192H115.808C119.013 93.0192 121.67 95.6763 121.67 98.8804C121.67 102.084 119.013 104.741 115.808 104.741H76.7344V116.464H100.179C103.383 116.464 106.04 119.121 106.04 122.325C106.04 125.529 103.383 128.186 100.179 128.186H76.7344V139.908H84.5492C87.7533 139.908 90.4103 142.565 90.4103 145.769C90.4103 148.973 87.7533 151.63 84.5492 151.63H76.7344V161.399H162.697C171.294 161.399 178.327 154.366 178.327 145.769V75.4359C178.327 71.1378 174.81 67.6211 170.512 67.6211Z",
    fill: "#C4C4C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3638 93.0195H68.9236C65.7195 93.0195 63.0625 95.6766 63.0625 98.8806C63.0625 102.085 65.7195 104.742 68.9236 104.742H76.7384V98.8806C76.7384 96.8488 76.973 94.8951 77.3638 93.0195Z",
    fill: "#C4C4C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9236 116.465C65.7195 116.465 63.0625 119.122 63.0625 122.326C63.0625 125.53 65.7195 128.187 68.9236 128.187H76.7384V116.465H68.9236Z",
    fill: "#C4C4C4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9236 139.91C65.7195 139.91 63.0625 142.567 63.0625 145.771C63.0625 148.975 65.7195 151.632 68.9236 151.632H76.7384V139.91H68.9236Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShippersEmpty);
export default __webpack_public_path__ + "static/media/ShippersEmpty.a7d429bab2ba8c5273ea664c76162441.svg";
export { ForwardRef as ReactComponent };